<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto;">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem" style="width: 80%">
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">治安信息</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-row>
        <el-col :span="12">
          <el-form-item label="填报日期" prop="ReportTime">
            <el-date-picker
              v-model="ruleForm.ReportTime"
              type="date"
              format="yyyy-MM-dd"
              :disabled="true"
              style="width: 100%"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="治安类型">
            <el-select
              v-model="ruleForm.SecurityType"
              v-bind:disabled="!IsEdit"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in SecurityTypeArr"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.ItemValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="治安等级" prop="SecurityLevel">
            <el-input
              v-model="ruleForm.SecurityLevel"
              v-bind:disabled="!IsEdit"
              placeholder="请填写治安等级"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地点" prop="Extends1">
            <el-input v-model="ruleForm.Extends1" v-bind:disabled="!IsEdit" placeholder="请填写地点"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="Extends2">
            <el-input
              v-model="ruleForm.Extends2"
              :disabled="!IsEdit"
              type="textarea"
              :autosize="{ minRows: 5 }"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :disabled="!IsEdit"
          v-if="IsEdit"
        >提交</el-button>
        <!--      <el-button @click="resetForm('')" :disabled="!IsEdit" v-if="IsEdit">重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
// import waitAll from "../../../../../../utils/src/waitAll";

export default {
  name: "SecurityAdd",
  controller: "UI",
  action: "SecurityAdd",
  data() {
    return {
      ruleForm: {
        // ID: '',
        // ReportDate: '', //上报日期
        // TimeSolt: '', //时间段
        // TicketData: '', //售票张数
        // Income: '', //售票金额
        // VisitorData: '', //接待游客量
        // OutGardenNum: '', //出园游客量
        // Turnover: '', //全园经济收入
        // CompanyId: this.user.Departments[0].OrgId,  //企业ID（登录人的部门）
        // CompanyName: this.user.Departments[0].OrgName, //企业名称（登录人的部门名称）
        // CreateTime: '', //创建时间
        // Creater: this.user.UserName //创建人
      },
      rules: {
        ReportDate: [
          { required: true, message: "请选择填报日期", trigger: "blur" }
        ],
        RentOutNum: [
          { required: true, message: "请填写租出车辆数量", trigger: "blur" }
        ],
        Turnover: [
          { required: true, message: "请填写营业金额", trigger: "blur" }
        ]
      },
      IsEdit: false,
      DeviceTypesArr: [],
      RegionData: [],
      SecurityTypeArr: []
    };
  },
  created: function() {
    //当前设定的日期时间
    this.ruleForm.ReportDate = new Date();

    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "look") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  mounted: function() {
    this.getSecurityType();
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    }
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    getSecurityType() {
      //预警类型
      this.config
        .getUValue("cyjc:SecurityType", "")
        .then(d => {
          this.SecurityTypeArr = d.JValue;
        })
        .catch(e => console.error(e));
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      let that = this;
      if (InfoId) {
        let searchInfo = { ID: InfoId };
        new MyApis.TbTourSecurityApi()
          .GeItemById(searchInfo)
          .then(r => {
            r = r.data.Data;
            // console.log(r);
            that.ruleForm = r;
            that.ruleForm.SecurityType = that.ruleForm.SecurityType.toString();
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.loadingText = "保存中...";
          if (this.$route.query.type == "add") {
            this.Add();
          } else if (this.$route.query.type == "edit") {
            this.Edit();
          }
        } else {
          return false;
        }
      });
    },
    Add() {
      this.ruleForm.ID = ZJApp.ZJUtils.uuid();
      this.ruleForm.CreateTime = new Date();
      this.ruleForm.Creater = ZJApp.ZJUser.current.UserName;
      this.ruleForm.ModifyTime = new Date();
      this.ruleForm.Modifier = ZJApp.ZJUser.current.UserName;
      this.ruleForm.ReportTime = new Date();
      this.ruleForm.CompanyId = this.user.Departments[0].OrgId;
      this.ruleForm.CompanyName = this.user.Departments[0].OrgName;
      this.ruleForm.Validity = 1;

      new MyApis.TbTourTravelCarApi()
        .AddItem(this.ruleForm)
        .then(r => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！"
          });
          this.logInfo.ActionName = "旅游汽车运营信息添加";
          this.logInfo.LogMessage = r
            ? "旅游汽车运营信息添加成功"
            : "旅游汽车运营信息添加失败";
          this.logInfo.ModuleName = "产业监测填报";
          this.logInfo.PageName = "旅游汽车运营基础信息";
          this.addOperationLog();
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch(e => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    Edit() {
      this.ruleForm.ModifyTime = new Date();
      this.ruleForm.Modifier = ZJApp.ZJUser.current.UserName;

      new MyApis.TbTourTravelCarApi()
        .UpdateItem(this.ruleForm)
        .then(r => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！"
          });
          this.logInfo.ActionName = "旅游汽车运营信息修改";
          this.logInfo.LogMessage = r
            ? "旅游汽车运营信息修改成功"
            : "旅游汽车运营信息修改失败";
          this.logInfo.ModuleName = "产业监测填报";
          this.logInfo.PageName = "旅游汽车运营基础信息";
          this.addOperationLog();
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch(e => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    }
  }
};
</script>
<style type="text/css"></style>
